const benefits = [
  {
    icon: "ri-time-line",
    title: "自由時間",
    desc: "隨時隨地開啟你的直播間，不受朝九晚五束縛，時間完全由你掌控。",
    highlight: "彈性工作",
  },
  {
    icon: "ri-camera-line",
    title: "形象攝影",
    desc: "提供專業形象攝影服務，打造你的個人品牌，讓你在平台上脫穎而出。",
    highlight: "免費拍攝",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "直播技巧教學",
    desc: "專業團隊手把手教學，從設備設定到互動技巧，零經驗也能快速上手。",
    highlight: "專業培訓",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "流量扶持",
    desc: "平台流量資源傾斜，讓你的才華被更多人看見，快速累積鐵粉圈。",
    highlight: "資源曝光",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "努力看得見",
    desc: "透明收益機制，付出多少回報多少，努力的成果直接反映在收入上。",
    highlight: "收益透明",
  },
  {
    icon: "ri-heart-3-line",
    title: "鐵粉社群",
    desc: "建立專屬於你的鐵粉圈，與粉絲建立深度連結，打造個人影響力。",
    highlight: "粉絲經營",
  },
];

const platforms = [
  { name: "17LIVE", color: "bg-red-100 text-red-700 border-red-200" },
  { name: "浪LIVE", color: "bg-orange-100 text-orange-700 border-orange-200" },
  { name: "其他綠色平台", color: "bg-green-100 text-green-700 border-green-200" },
];

export default function RecruitBenefits() {
  return (
    <section id="recruit-benefits" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Platforms */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-red-50 text-red-600 text-xs font-semibold tracking-widest uppercase mb-4">
            Platforms
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif TC', serif" }}>
            合作直播平台
          </h2>
          <div className="flex flex-wrap justify-center gap-3 mb-6">
            {platforms.map((p) => (
              <span key={p.name} className={`px-6 py-2.5 rounded-full border text-sm font-bold ${p.color}`}>
                {p.name}
              </span>
            ))}
          </div>
          <p className="text-gray-500 text-sm max-w-xl mx-auto">
            與主流直播平台深度合作，提供最完整的資源支援與流量扶持
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900" style={{ fontFamily: "'Noto Serif TC', serif" }}>
              加入我們的好處
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((b) => (
              <div key={b.title} className="rounded-2xl border border-gray-100 bg-stone-50 p-7 hover:-translate-y-1 transition-transform duration-200">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-red-100 text-red-600 mb-4">
                  <i className={`${b.icon} text-xl`} />
                </div>
                <div className="inline-block px-2.5 py-0.5 rounded-full bg-red-600 text-white text-xs font-semibold mb-2">
                  {b.highlight}
                </div>
                <h4 className="font-bold text-gray-900 text-base mb-2">{b.title}</h4>
                <p className="text-gray-500 text-sm leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Who We Want */}
        <div className="rounded-3xl bg-gradient-to-br from-stone-900 to-stone-800 p-10 md:p-14 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl md:text-3xl font-black mb-3" style={{ fontFamily: "'Noto Serif TC', serif" }}>
              我們在找的就是你！
            </h3>
            <p className="text-stone-400 text-sm mb-8">招募「高顏值 / 有才藝」直播主</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              {[
                { icon: "ri-chat-smile-3-line", label: "愛聊天", desc: "親和力強，擅長與人互動" },
                { icon: "ri-music-line", label: "有才藝", desc: "歌唱、舞蹈、樂器皆可" },
                { icon: "ri-smartphone-line", label: "愛分享", desc: "對社群經營有熱忱" },
              ].map((item) => (
                <div key={item.label} className="rounded-2xl bg-white/10 p-6 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-600 mx-auto mb-3">
                    <i className={`${item.icon} text-xl text-white`} />
                  </div>
                  <div className="font-bold text-white text-base mb-1">{item.label}</div>
                  <div className="text-stone-400 text-xs">{item.desc}</div>
                </div>
              ))}
            </div>
            <div className="bg-white/5 rounded-2xl p-6 text-left mb-8">
              <p className="text-stone-300 text-sm leading-loose">
                📣 世界很大，但你缺一個發光的舞台？<br />
                📣 你是否也曾想過，讓更多人聽見你的歌聲、看見你的熱情？<br />
                🌟 不必等選秀，現在就加入我們！<br />
                🌟 只要你敢秀、愛分享、有親和力，你就是我們要找的明日之星。<br />
                🌟 夢想不該只是想像，立即報名，成為最閃耀的直播主！
              </p>
            </div>
            <a
              href="#recruit-form"
              className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-red-600 text-white font-bold text-sm hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-user-add-line" />
              立即私訊，預約面試機會
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
